import { Component, OnInit } from '@angular/core';
import {Router, RouterModule} from '@angular/router';


@Component({
  selector: 'app-admin',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})

export class LayoutComponent implements OnInit {
  public activeURL:String;
  expanded = false;
  navbarOpen = false;
  isNavbarCollapsed:boolean
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }
  

    ngOnInit(){
      this.activeURL = window.location.href;
      console.log('Active URL : ' + this.activeURL);
    }
    
    constructor(private router :Router){
      this.router.routeReuseStrategy.shouldReuseRoute = function() {
        return false;
      };
    }

    
}

